"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const utils_1 = require("../controls/utils");
const Slider = (props) => {
    const isDataNonNullObject = typeof props.data === "object" &&
        props.data !== undefined &&
        props.data !== null;
    const isDataEmptyObj = isDataNonNullObject
        ? Object.keys(props.data).length === 0
        : false;
    const defaultValue = typeof props.schema?.default === "number"
        ? props.schema.default
        : props.schema.minimum;
    const value = props.data === undefined || isDataEmptyObj
        ? defaultValue
        : props.data;
    const addonAfter = props.uischema.options?.addonAfter;
    const addonBefore = props.uischema.options?.addonBefore;
    const isPercentage = addonAfter?.trim() === "%";
    const min = props.schema.minimum;
    const max = props.schema.maximum;
    const step = props.schema.multipleOf;
    const numberType = props.schema.type;
    const isInteger = (typeof numberType === "string" && numberType === "integer") ||
        (Array.isArray(numberType) && numberType.includes("integer"));
    const handleChange = (value) => {
        if (min !== undefined &&
            value >= min &&
            max !== undefined &&
            value <= max) {
            if (isInteger) {
                props.handleChange(props.path, value !== null ? (0, utils_1.coerceToInteger)(value) : value);
            }
            else {
                props.handleChange(props.path, value !== null ? (0, utils_1.coerceToNumber)(value) : value);
            }
        }
    };
    const tooltip = {
        formatter: (value) => {
            const tooltipValue = value !== undefined ? value : defaultValue;
            const formattedTooltipValue = isPercentage
                ? (0, utils_1.decimalToPercentage)(tooltipValue)
                : tooltipValue;
            return `${addonBefore ? addonBefore : ""}${formattedTooltipValue}${addonAfter ? addonAfter : ""}`;
        },
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Slider, { defaultValue: defaultValue, value: value, onChange: (value) => handleChange(value), min: min, max: max, step: step, tooltip: tooltip }));
};
exports.Slider = Slider;
